import React from "react";
import { motion } from "framer-motion";
import { Space, Typography } from "antd";
import { FaPlane } from "react-icons/fa";
import { useAppContext } from "../../contexts/AppContext";
import "./style.css";

const { Text } = Typography;

const AirlineDisplay = ({ flightNumber, airlineId, isCompact = false }) => {
  const { airlines, isMobile } = useAppContext();

  const airline =
    airlines?.find((airline) => airline.code === airlineId) || undefined;

  if (isCompact) {
    return (
      <motion.div
        className="airline-compact"
        style={{
          display: "flex",
          flexDirection: "column",
          width: "100%",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 10,
        }}
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.3 }}
        whileHover={{ scale: 1.02 }}
      >
        {airline ? (
          <img
            src={airline.logo}
            alt={airline.name}
            className="airline-logo-compact"
            style={{ width: isMobile ? "80%" : "50%", maxWidth: 200 }}
          />
        ) : (
          <motion.div
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
            className="airline-logo-fallback"
          >
            <FaPlane className="fallback-icon" />
          </motion.div>
        )}
      </motion.div>
    );
  }

  return (
    <motion.div
      className="airline-display"
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.3 }}
      whileHover={{ scale: 1.02 }}
    >
      <Space
        direction="vertical"
        size="small"
        align="center"
        className="airline-content"
      >
        {airline ? (
          <motion.div
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
            className="airline-logo-container"
          >
            <img
              src={airline.logo}
              alt={airline.name}
              className="airline-logo-image"
            />
          </motion.div>
        ) : (
          <motion.div
            whileHover={{ scale: 1.05 }}
            transition={{ duration: 0.2 }}
            className="airline-logo-fallback"
          >
            <FaPlane className="fallback-icon" />
          </motion.div>
        )}

        <Space
          direction="vertical"
          size={2}
          align="center"
          className="airline-info"
        >
          {airline && (
            <Text
              className="airline-name-text"
              ellipsis={{ tooltip: airline.name }}
            >
              {airline.name}
            </Text>
          )}
          <Text className="flight-number" strong>
            {flightNumber}-{airlineId}
          </Text>
        </Space>
      </Space>
    </motion.div>
  );
};

export default AirlineDisplay;
